'use client';

import { useRef } from 'react';
import useContactForm from '@/lib/hooks/useContactForm';
import cn from '@/lib/packages/cn';
import { helperTextVariants, inputVariants } from '@/lib/packages/tailwind.variants';
import Form from '@/ui/Form';
import Input from '@/ui/Input';
import SubmitButton from '@/ui/SubmitButton';
import Textarea from '@/ui/Textarea';

const _FORM_ID = 'contact';
const _FORM_NAME = 'Contact form';

const ContactForm = () => {
  const { form, handleSubmit } = useContactForm();
  const _startedRef = useRef<boolean>(false);
  const viewRef = useRef<HTMLDivElement | null>(null);
  const _hasSentViewRef = useRef<boolean>(false);

  // Removed form_view analytics: EM/GA4 handles form tracking

  // Removed form_error analytics

  // Removed form_start analytics

  return (
    <div ref={viewRef} className='w-full'>
      <Form form={form} onSubmit={handleSubmit} className='mx-auto max-w-md space-y-6'>
        <div className='grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2'>
          <Input name='firstName' label='First Name' type='text' autoComplete='given-name' />
          <Input name='lastName' label='Last Name' type='text' autoComplete='family-name' />
        </div>
        <Input name='company' label='Company' type='text' autoComplete='organization' />
        <fieldset className='w-full space-y-2'>
          <legend className='text-sm font-medium text-secondary'>Role</legend>
          <div
            className={cn(
              inputVariants({ variant: form.formState.errors.roles ? 'error' : 'default' }),
              'flex w-full flex-wrap items-center gap-4 bg-white py-2 text-sm text-secondary dark:bg-gray-900 dark:text-white',
            )}
          >
            {['Broker', 'Trader', 'Physical Supplier'].map((role) => (
              <label key={role} className='inline-flex items-center gap-2'>
                <input
                  type='checkbox'
                  value={role}
                  className='relative h-5 w-5 cursor-pointer appearance-none rounded border border-gray-300 bg-white align-middle text-white focus:outline-none focus:ring-2 focus:ring-info checked:border-info checked:bg-info before:pointer-events-none before:absolute before:inset-0 before:flex before:items-center before:justify-center before:text-base before:font-semibold before:text-transparent before:content-["✓"] checked:before:text-white dark:border-white/20 dark:bg-gray-900'
                  {...form.register('roles')}
                />
                <span>{role}</span>
              </label>
            ))}
          </div>
          {form.formState.errors.roles?.message ? (
            <p className={helperTextVariants({ variant: 'error' })}>{form.formState.errors.roles.message as string}</p>
          ) : null}
        </fieldset>
        <Input name='mobile' label='Mobile' type='tel' autoComplete='tel' />
        <Input name='email' label='Email' type='email' autoComplete='email' />
        <Textarea name='message' label='Message' rows={6} size='md' autoComplete='off' />
        <div className='flex justify-end'>
          <SubmitButton>Send message</SubmitButton>
        </div>
      </Form>
    </div>
  );
};

export default ContactForm;
